import { render } from "./CreditRequestInfo.vue?vue&type=template&id=b23088b6"
import script from "./CreditRequestInfo.vue?vue&type=script&lang=js"
export * from "./CreditRequestInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__